// for unassigment of employee
export const RESET_CUSTOMER_BANK_INFO = "resign_customer_bank_info";
export const CUSTOMER_BANK_INFO = "customer_bank_info";
export const CUSTOMER_BANK_INFO_SUCCESS = "customer_bank_info_success";
export const CUSTOMER_BANK_INFO_FAILURE = "customer_bank_info_failure";
